require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-cspf-key-takeaways.json") })
        }
      }, "path---en-us-update-cspf-key-takeaways");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-cspf-key-takeaways!./.cache/json/en-us-update-cspf-key-takeaways.json
// module id = 651
// module chunks = 231608221292675